<template>
  <div class="bui-entity-listing-page slide-editor-redesign">
    <div class="slide-editor-redesign__inner">
      <TopHigherHorizontalBar :isReadOnly="isReadOnly" />
      <TopLowerHorizontalBar :isReadOnly="isReadOnly" />

      <div
        class="slide-editor-container"
        style="display: flex;"
        tabindex="0"
        @keydown.prevent="!isReadOnly && keyboardKeysStageHandlers.onKeyDown"
        @keyup.prevent="!isReadOnly && keyboardKeysStageHandlers.onKeyUp">
        <Stage :isReadOnly="isReadOnly" />
        <SidePanes v-if="!isReadOnly" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Stage from './Stage/Stage.vue';
import SidePanes from './PropertiesPanesRight/PropertiesPanesRight.vue';
  // to rename /think-name later ASAP: PropertiesPanesRight
import TopHigherHorizontalBar from './TopHigherHorizontalBar/TopHigherHorizontalBar.vue';
import TopLowerHorizontalBar from './TopLowerHorizontalBar/TopLowerHorizontalBar.vue';
import useKeyboardKeysStageHandlers from './Stage/stageEvents/handlers/keyboardKeysStageHandlers';
import useSlide from './composables/slide';
import { provide } from 'vue';

const props = defineProps<{
  isReadOnly: boolean;
  data?: any;
}>();

provide('isReadOnly', props.isReadOnly);

const { initializeSlideEditorHelperWatchers } = useSlide();
initializeSlideEditorHelperWatchers();

const keyboardKeysStageHandlers = useKeyboardKeysStageHandlers();

</script>

<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';

/* Outer wrapper: paints the BUI page surface edge-to-edge (see the note in
   PlayerEditorView — `.bui-entity-listing-page` is wired in PageLayout.vue).
   The Konva stage sizes itself from its container on mount, so the surface
   padding is safe for the canvas. */
.slide-editor-redesign {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  background: var(--bui-page-fill, #ff007b);
  color: var(--bui-page-head, #fffcfd);
  padding: var(--bui-page-pad-y, 32px) var(--bui-page-pad-x, 48px) 3rem;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.slide-editor-redesign__inner {
  display: flex;
  flex-direction: column;
  gap: var(--bui-page-section-gap, 24px);
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
}

.slide-editor-container {
  flex-wrap: nowrap;
  padding: 0;
  justify-content: space-between;

  &:focus {
    outline: none;
  }
}
</style>
